import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AbstractService } from '@core/http/abstract.service';

import { ApiResponse } from './items-rain.entity';

@Injectable({
  providedIn: 'root'
})
export class ItemsRainService extends AbstractService {
  protected override prefix = '/items-rain';

  getMyPlace(): Observable<ApiResponse.MyPlace> {
    return this.get<ApiResponse.MyPlace>('/my-place');
  }

  getPreviousPeriod(): Observable<ApiResponse.PreviousPeriod> {
    return this.get<ApiResponse.PreviousPeriod>('/previous');
  }
}